import mediaQueries from "./media-queries";

export default {
  maxWidth: "770px",
  margin: "0 auto",
  "& .narrowPageContent": {
    maxWidth: "530px",
    margin: "0 auto",
  },
  "& h1": {
    fontFamily: "JWSansBold",
    color: "#000000",
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: "24px",
    lineHeight: "30px",
    letterSpacing: "5px",
    [mediaQueries.tablet]: {
      fontSize: "30px",
      lineHeight: "46px",
    }
  },
  "& h2": {
    fontFamily: "JWSansBold",
    color: "#000000",
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: "18px",
    lineHeight: "30px",
    letterSpacing: "3.5px",
    [mediaQueries.tablet]: {
      fontSize: "20px",
      lineHeight: "26px"
    }
  },
  "& h3": {
    fontFamily: "JWSansBook",
    fontWeight: "normal",
    textTransform: "uppercase",
    paddingTop: "11px",
    fontSize: "18px",
    lineHeight: "21px",
    letterSpacing: "2px",
    [mediaQueries.tablet]: {
      fontSize: "22px",
    lineHeight: "20px",
    }
  },
  "& h4": {
    fontFamily: "JWSansBook",
    fontSize: "14px",
    fontWeight: "normal",
    letterSpacing: "2.5px",
    textTransform: "uppercase",
    lineHeight: 1.22,
    paddingTop: "11px"
  },
  "& a": {
    color: "white",
    cursor: "pointer",
    textDecoration: "underline"
  },
  "& p, & li": {
    fontFamily: "JWSansBook",
    fontSize: "12px",
    color: "#000000",
    lineHeight: "16px",
    letterSpacing: "0.45px",
    padding: "0 12px",
    margin: "1rem 0",
    "& strong": {
      fontFamily: "JWSansBold"
    }
  },
  "& p": {
    padding: 0
  }
};



// WEBPACK FOOTER //
// ./src/styles/generic.js